var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          class: [
            "parametric",
            {
              "is-ready": _vm.isReady,
              "is-overlay": _vm.isFilterOpen
            }
          ]
        },
        [
          _c("Results"),
          _vm._v(" "),
          _c("Filters", {
            ref: "filter",
            attrs: { isFilterOpen: _vm.isFilterOpen },
            on: {
              close: function($event) {
                _vm.isFilterOpen = false
              },
              openModal: _vm.openGenplan
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("GenplanPopup", {
        ref: "genplanModal",
        on: { sendBuilding: _vm.buildingSelect }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }